<template>
    <AxRoadPage :title="$t('measurements')">
        <div class="l-stack l-gap-3">
            <DateSelect v-model="selectedDate" :marked-days="warningDates" />
            <WarningAlert
                v-for="warning in currentWarnings"
                :key="warning.id"
                :warning="warning"
            />
            <MeasurementsChart
                v-if="selectedDate && truck && measurements"
                :asset="truck"
                :date="selectedDate"
                :measurements="measurements"
            />
            <div v-else>
                {{ $t('no_measurements') }}
            </div>
        </div>
    </AxRoadPage>
</template>

<script>
import DateSelect from '@/components/ax-road/DateSelect.vue'
import MeasurementsChart from '@/components/ax-road/MeasurementsChart.vue'
import WarningAlert from '@/components/ax-road/WarningAlert.vue'
import AxRoadPage from '@/components/ax-road/AxRoadPage.vue'
import { mapGetters } from 'vuex'

// import measurementHelper from '@/utils/modules/measurement.helper'
import moment from 'moment'

export default {
    name: 'TruckMeasurementsView',
    components: {
        AxRoadPage,
        WarningAlert,
        MeasurementsChart,
        DateSelect,
    },
    data() {
        return {
            selectedDate: moment().format('YYYY-MM-DD'),
        }
    },
    computed: {
        ...mapGetters('warnings', ['assetWarningsMap']),
        ...mapGetters('tracker', ['assetsById']),
        truck() {
            return this.assetsById[this.$route.params.id] || null
        },
        warnings() {
            return (this.assetWarningsMap[this.truck.asset] || []).filter(
                warning => !warning.resolved
            )
        },
        warningDates() {
            return this.warnings.map(warning =>
                moment(warning.timestamp).format('YYYY-MM-DD')
            )
        },
        currentWarnings() {
            return this.warnings.filter(warning =>
                moment(warning.timestamp).isSame(this.selectedDate, 'day')
            )
        },
        title() {
            return this.measurements.length === 1
                ? this.$t('shared.measurements.' + this.measurements[0]) ||
                      this.$t('measurements')
                : this.$t('measurements')
        },
        measurements() {
            const queryMeasurements = this.$route.query.measurements
            return queryMeasurements
                ? Array.isArray(queryMeasurements)
                    ? queryMeasurements
                    : [queryMeasurements]
                : []
        },
    },
    watch: {
        '$route.query.date': {
            handler(newDate) {
                this.selectedDate = newDate || moment().format('YYYY-MM-DD')
            },
            immediate: true,
        },
        selectedDate: {
            handler(newDate) {
                this.$router.push({
                    ...this.$route,
                    query: { date: newDate, measurements: this.measurements },
                })
            },
            immediate: true,
        },
    },
}
</script>

<i18n>
{
    "en": {
        "measurements": "Measurements",
        "no_measurements": "No measurements available"
    },
    "de": {
        "measurements": "Messungen",
        "no_measurements": "Keine Messungen verfügbar"
    },
    "fr": {
        "measurements": "Mesures",
        "no_measurements": "Aucune mesure disponible"
    },
    "it": {
        "measurements": "Misurazioni",
        "no_measurements": "Nessuna misurazione disponibile"
    }
}
</i18n>
